import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.sentinels = []
    this.observers = []
    this.#initTables()
  }

  disconnect() {
    this.observers.forEach(obs => obs.disconnect())
    this.sentinels.forEach(s => s.remove())
  }

  #initTables() {
    this.element.querySelectorAll(".table-container").forEach(tc => {
      const sentinel = document.createElement("div")
      sentinel.setAttribute("aria-hidden", "true")
      sentinel.style.cssText = "height:1px;margin-top:-1px;pointer-events:none;visibility:hidden;"
      tc.insertAdjacentElement("afterbegin", sentinel)
      this.sentinels.push(sentinel)

      const observer = new IntersectionObserver(
        entries => this.#handleIntersection(entries),
        { root: tc, threshold: 0 }
      )
      observer.observe(sentinel)
      this.observers.push(observer)
    })
  }

  #handleIntersection(entries) {
    entries.forEach(entry => {
      const thead = entry.target.parentElement?.querySelector("thead")
      if (thead) thead.toggleAttribute("data-stuck", !entry.isIntersecting)
    })
  }
}
